import { createExporter } from "utils/createExporter";

export const SecurityExporter = (name) => createExporter(`account_${name}.xlsx`,
    [
        { key: "name", label: "име" },
        { key: "description", label: "описание" },
    ],
    (record) => ({
        ...record,
    })
);

export const PermissionsExporter = (name) => createExporter(`account_${name}.xlsx`,
    [
        { key: "name", label: "име" },
        { key: "description", label: "описание" },
        { key: "roles", label: "роли" },
    ],
    (record) => ({
        ...record,
        roles: record.roles?.map(role => role.name).join(", ") ?? "",
    })
);
